<svelte:options customElement="glp1-main" />

<script> 
	import { onMount } from "svelte";
	import { loadAssets, baseUrl } from "../../ursCommon/Common.svelte";
	import GlobalLoader, { Loader } from "../../ursCommon/GlobalLoader.svelte"
	import Glp1 from './Glp1.svelte';
	
	let apiPromise;

	
	//if we decide to get list of available pre-auth forms, then do something here to get them from the server
	async function fetchPharmacyPreAuthForms() {
		Loader.display();
		const data = {formName: "GLP-1"};
		return data;
		Loader.hide();
	}

	onMount( async () => {
		setTimeout(() => {
			loadAssets("glp1-main");
		}, 10);
	});

</script>

<Glp1/>

<GlobalLoader />